import React, { useState } from 'react';
import { Instagram, Mail, Facebook, Globe } from 'lucide-react';
import { PrivacyPolicyModal } from './PrivacyPolicyModal';
import { TermsAndConditionsModal } from './TermsAndConditionsModal';
export function Footer() {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  return <>
      <footer className="bg-[#050714] border-t border-white/5 pt-16 pb-8" data-id="element-49">
        <div className="container mx-auto px-4 max-w-7xl" data-id="element-50">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-51">
            {/* Brand Column */}
            <div className="col-span-1 md:col-span-2" data-id="element-52">
              <div className="flex items-center gap-4 mb-6" data-id="element-53">
                <img src="https://cdn.magicpatterns.com/uploads/3kBgnD6e6XdAgLnALwYUbB/levelup_logo_negativo.png" alt="LevelUp Play Logo" className="h-12 object-contain" data-id="element-54" />
                <a href="https://www.aede.ec" target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition-opacity" data-id="element-55">
                  <img src="https://cdn.magicpatterns.com/uploads/qys2hZNJzSrnSmXKRJdiLS/pasted-image.png" alt="AEDE Logo" className="h-12 object-contain" data-id="element-56" />
                </a>
              </div>
              <p className="text-gray-400 mb-6 max-w-md" data-id="element-57">
                La plataforma oficial de fidelización de la Asociación
                Ecuatoriana de Deportes Electrónicos. Llevando el gaming en
                Ecuador al siguiente nivel.
              </p>
              <div className="flex gap-4" data-id="element-58">
                <a href="https://www.facebook.com/AEDEecuador/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/5 rounded-full flex items-center justify-center text-gray-400 hover:bg-gaming-purple hover:text-white transition-all" data-id="element-59">
                  <Facebook className="w-5 h-5" data-id="element-60" />
                </a>
                <a href="https://www.instagram.com/aedeecuador/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/5 rounded-full flex items-center justify-center text-gray-400 hover:bg-gaming-purple hover:text-white transition-all" data-id="element-61">
                  <Instagram className="w-5 h-5" data-id="element-62" />
                </a>
              </div>
            </div>

            {/* Legales Column */}
            <div data-id="element-63">
              <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-64">
                Legales
              </h4>
              <ul className="space-y-3" data-id="element-65">
                <li data-id="element-66">
                  <button onClick={() => setShowPrivacyModal(true)} className="text-gray-400 hover:text-gaming-cyan transition-colors text-left" data-id="element-67">
                    Política de Privacidad
                  </button>
                </li>
                <li data-id="element-68">
                  <button onClick={() => setShowTermsModal(true)} className="text-gray-400 hover:text-gaming-cyan transition-colors text-left" data-id="element-69">
                    Términos y Condiciones
                  </button>
                </li>
              </ul>
            </div>

            {/* Contacto Column */}
            <div data-id="element-70">
              <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-71">
                Contacto
              </h4>
              <ul className="space-y-3" data-id="element-72">
                <li data-id="element-73">
                  <a href="mailto:oficial@aede.ec" className="flex items-center gap-2 text-gray-400 hover:text-gaming-cyan transition-colors" data-id="element-74">
                    <Mail className="w-4 h-4" data-id="element-75" />
                    <span data-id="element-76">oficial@aede.ec</span>
                  </a>
                </li>
                <li data-id="element-77">
                  <a href="https://www.aede.ec" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-400 hover:text-gaming-cyan transition-colors" data-id="element-78">
                    <Globe className="w-4 h-4" data-id="element-79" />
                    <span data-id="element-80">www.aede.ec</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-81">
            <p className="text-gray-500 text-sm" data-id="element-82">
              © 2026 Asociación Ecuatoriana de Deportes Electrónicos en
              colaboración con TicketMaestro y su Plataforma Benefika. Todos los
              derechos reservados.
            </p>
            <p className="text-gray-600 text-sm flex items-center gap-1" data-id="element-83">
              Made with <span className="text-gaming-accent" data-id="element-84">♥</span> for
              gamers
            </p>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <PrivacyPolicyModal isOpen={showPrivacyModal} onClose={() => setShowPrivacyModal(false)} data-id="element-85" />

      {/* Terms and Conditions Modal */}
      <TermsAndConditionsModal isOpen={showTermsModal} onClose={() => setShowTermsModal(false)} data-id="element-86" />
    </>;
}